// ========================================
// Initialize All Components on DOM Ready
// ========================================
document.addEventListener('DOMContentLoaded', () => {
  
  // ========================================
  // Media Slider Height Management
  // ========================================
  const mediaTrack = document.querySelector('.media-sliders .gridy-track');
  if (mediaTrack) {
    function setHeight() {
      const active = mediaTrack.querySelector('.active > figure:not(.ccb-image)');
      const firstEl = mediaTrack.querySelector('.product-media:first-child > figure:not(.ccb-image)');
      
      if (active) {
        mediaTrack.style.height = `${active.offsetHeight}px`;
      } else {
        mediaTrack.style.height = `${firstEl.offsetHeight}px`;
      }
    }

    setHeight();
    window.addEventListener('resize', setHeight);

    const mediaObserver = new MutationObserver(setHeight);
    mediaObserver.observe(mediaTrack, { 
      attributes: true, 
      subtree: true, 
      attributeFilter: ['class'] 
    });
  }

  // ========================================
  // Testimonial Custom Scrollbar
  // ========================================
  const testimonialContainer = document.querySelector('.testimonial-container .gridy-track');
  const scrollTrack = document.getElementById('scrollTrack');
  const scrollThumb = document.getElementById('scrollThumb');
  const prevBtn = document.querySelector('[data-direction="prev"]');
  const nextBtn = document.querySelector('[data-direction="next"]');

  if (testimonialContainer && scrollTrack && scrollThumb) {
    // Scrollbar thumb update logic
    function updateThumb() {
      const scrollW = testimonialContainer.scrollWidth;
      const clientW = testimonialContainer.clientWidth;
      const trackW = scrollTrack.clientWidth;

      if (scrollW <= clientW) {
        scrollThumb.style.width = `${trackW}px`;
        scrollThumb.style.left = '0px';
        scrollThumb.style.opacity = '0.35';
        return;
      }

      const ratio = clientW / scrollW;
      const thumbW = Math.max(ratio * trackW, 24);
      const maxLeft = trackW - thumbW;
      const left = (testimonialContainer.scrollLeft / (scrollW - clientW)) * maxLeft;

      scrollThumb.style.width = `${thumbW}px`;
      scrollThumb.style.transform = `translateX(${left}px)`;
      scrollThumb.style.opacity = '1';
    }

    testimonialContainer.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    updateThumb();

    // Click on track to jump to position
    scrollTrack.addEventListener('click', (e) => {
      if (e.target === scrollThumb) return;
      
      const rect = scrollTrack.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const thumbW = scrollThumb.clientWidth;
      const trackW = scrollTrack.clientWidth;
      const maxLeft = trackW - thumbW;
      const targetLeft = Math.max(0, Math.min(clickX - thumbW / 2, maxLeft));
      const ratio = targetLeft / maxLeft;
      const newScroll = ratio * (testimonialContainer.scrollWidth - testimonialContainer.clientWidth);
      
      testimonialContainer.scrollTo({ left: newScroll, behavior: 'smooth' });
    });

    // Drag functionality
    let isDragging = false;
    let startX = 0;
    let startLeft = 0;

    function startDrag(e) {
      isDragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      startLeft = parseFloat(scrollThumb.style.transform.replace('translateX(', '')) || scrollThumb.offsetLeft;
      
      document.addEventListener('mousemove', onDrag);
      document.addEventListener('mouseup', endDrag);
      document.addEventListener('touchmove', onDrag, { passive: false });
      document.addEventListener('touchend', endDrag);
      
      e.preventDefault();
    }

    function onDrag(e) {
      if (!isDragging) return;
      
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const dx = clientX - startX;
      const trackW = scrollTrack.clientWidth;
      const thumbW = scrollThumb.clientWidth;
      const maxLeft = trackW - thumbW;
      
      let newLeft = startLeft + dx;
      newLeft = Math.max(0, Math.min(newLeft, maxLeft));
      
      scrollThumb.style.transform = `translateX(${newLeft}px)`;
      
      const ratio = newLeft / maxLeft;
      testimonialContainer.scrollLeft = ratio * (testimonialContainer.scrollWidth - testimonialContainer.clientWidth);
    }

    function endDrag() {
      isDragging = false;
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('mouseup', endDrag);
      document.removeEventListener('touchmove', onDrag);
      document.removeEventListener('touchend', endDrag);
    }

    scrollThumb.addEventListener('mousedown', startDrag);
    scrollThumb.addEventListener('touchstart', startDrag, { passive: false });

    // Previous/Next buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        testimonialContainer.scrollBy({ 
          left: -testimonialContainer.clientWidth * 0.8, 
          behavior: 'smooth' 
        });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        testimonialContainer.scrollBy({ 
          left: testimonialContainer.clientWidth * 0.8, 
          behavior: 'smooth' 
        });
      });
    }
  }

  // ========================================
  // Product Thumbnails Slider - Arrow Navigation
  // ========================================
  const thumbnailContainer = document.querySelector('.gridy-slider.product-thumbnails-slider');
  if (thumbnailContainer) {
    let isProcessing = false;

    const runActiveClick = (target) => {
      if (isProcessing) return;

      isProcessing = true;
      console.log('target', target);
      
      if (target && target.classList.contains('active')) {
        target.click();
      }

      setTimeout(() => {
        isProcessing = false;
      }, 100);
    };

    // Click initial active thumbnail
    const initialActive = thumbnailContainer.querySelector('[data-thumbnail-btn].active');
    if (initialActive) {
      initialActive.click();
    }

    // Observe class changes on thumbnail buttons
    const thumbnailObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.matches('[data-thumbnail-btn]')
        ) {
          const target = mutation.target;

          if (target.classList.contains('active')) {
            runActiveClick(target);
            break;
          }
        }
      }
    });

    thumbnailObserver.observe(thumbnailContainer, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }

  // ========================================
// Product Description Truncation with Read More
// ========================================
const descriptionContainer = document.querySelector('.product-block__description .rte');
if (descriptionContainer) {
  const maxLength = 150;
  
  // Remove only empty HTML tags (no content inside)
  function removeEmptyTags(element) {
    // Self-closing tags that should be preserved
    const selfClosingTags = ['BR', 'HR', 'IMG', 'INPUT', 'META', 'LINK'];
    
    // Run multiple times to catch deeply nested empty tags
    for (let i = 0; i < 3; i++) {
      const allElements = element.querySelectorAll('*');
      allElements.forEach((el) => {
        // Skip self-closing tags
        if (selfClosingTags.includes(el.tagName)) {
          return;
        }
        
        // Get text content and remove all whitespace characters
        const textContent = el.textContent.replace(/\s+/g, '');
        
        // Check if element has no meaningful children and no text
        const meaningfulChildren = Array.from(el.children).filter(child => 
          selfClosingTags.includes(child.tagName) || child.textContent.trim() !== ''
        );
        
        if (meaningfulChildren.length === 0 && textContent === '') {
          el.remove();
        }
      });
    }
  }
  
  // Clean empty tags first
  removeEmptyTags(descriptionContainer);
  
  // Store original content after cleaning
  const contentFull = descriptionContainer.innerHTML;
  const contentFullText = descriptionContainer.textContent.trim();
  
  // Only truncate if content exceeds maxLength
  if (contentFullText.length > maxLength) {
    let currentLength = 0;
    const walker = document.createTreeWalker(
      descriptionContainer, 
      NodeFilter.SHOW_TEXT, 
      null, 
      false
    );

    const nodesToRemove = [];
    let reachedLimit = false;

    while (walker.nextNode()) {
      const node = walker.currentNode;
      const text = node.textContent.trim();

      if (!reachedLimit) {
        if (currentLength + text.length > maxLength) {
          const allowed = maxLength - currentLength;
          node.textContent = text.slice(0, allowed) + '…';
          reachedLimit = true;
        } else {
          currentLength += text.length;
        }
      } else {
        nodesToRemove.push(node);
      }
    }

    nodesToRemove.forEach((node) => {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });
    
    // Remove empty tags again after truncation
    removeEmptyTags(descriptionContainer);
    
    const truncatedContent = descriptionContainer.innerHTML;

    // Create Read More button
    const readMoreBtn = document.createElement('button');
    readMoreBtn.className = 'read-more-btn';
    readMoreBtn.textContent = 'Read More';
    readMoreBtn.style.cssText = 'margin-top:10px;cursor:pointer;font-size:16px;transition: all 0.3s;text-decoration:underline;';
    
    descriptionContainer.insertAdjacentElement('afterend', readMoreBtn);

    let isExpanded = false;

    readMoreBtn.addEventListener('click', () => {
      if (isExpanded) {
        descriptionContainer.innerHTML = truncatedContent;
        readMoreBtn.textContent = 'Read More';
        isExpanded = false;
      } else {
        descriptionContainer.innerHTML = contentFull;
        readMoreBtn.textContent = 'Read Less';
        isExpanded = true;
      }
    });
  }

  descriptionContainer.style.display = 'block';
}

});